import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: '売り会社の一覧表', path: '/company-list' },
    { name: '会社を売る', path: '/sell' },
    { name: '会社を買う', path: '/buy' },
    { name: '稼働法人の譲渡', path: '/active-company-transfer' },
    { name: '成約事例', path: '/cases' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      isScrolled 
        ? 'bg-white/95 backdrop-blur-lg shadow-lg' 
        : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group cursor-pointer">
            <div className={`text-3xl font-black tracking-tight transition-all duration-300 ${
              isScrolled 
                ? 'text-gray-900' 
                : 'text-white'
            }`}>
              <span className="bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">NEXT</span>
              <span className={isScrolled ? 'text-gray-900' : 'text-white'}>AGE</span>
            </div>
            <div className={`ml-3 text-xs font-bold tracking-wider transition-all duration-300 ${
              isScrolled 
                ? 'text-gray-600' 
                : 'text-white/90'
            }`}>
              会社売買
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-5 py-2 rounded-full text-sm font-bold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  isScrolled
                    ? 'text-gray-700 hover:text-teal-600 hover:bg-teal-50'
                    : 'text-white hover:text-teal-300 hover:bg-white/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Link
              to="/contact"
              className={`group relative px-8 py-3 rounded-full text-sm font-bold transition-all duration-300 overflow-hidden whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-gradient-to-r from-teal-500 to-cyan-500 text-white hover:shadow-lg hover:shadow-teal-500/30'
                  : 'bg-white text-gray-900 hover:bg-teal-50'
              }`}
            >
              <span className="relative z-10 flex items-center">
                お問い合わせ
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </span>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 cursor-pointer ${
              isScrolled
                ? 'bg-gray-100 text-gray-900'
                : 'bg-white/10 backdrop-blur-md text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden transition-all duration-500 overflow-hidden ${
        isMobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
      }`}>
        <div className="bg-white/95 backdrop-blur-lg border-t border-gray-200 shadow-lg">
          <div className="max-w-7xl mx-auto px-4 py-6 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-6 py-3 rounded-xl text-sm font-bold text-gray-700 hover:text-teal-600 hover:bg-teal-50 transition-all cursor-pointer"
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-6 py-3 rounded-xl text-sm font-bold bg-gradient-to-r from-teal-500 to-cyan-500 text-white text-center hover:shadow-lg transition-all cursor-pointer"
            >
              お問い合わせ
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
